module.exports = __webpack_public_path__ + "img/qrcode.e8ef6e43.png";